import { makeStyles } from "@material-ui/core/styles";

// *** PRODUCT -- img, price etc ***

export default makeStyles((theme) => ({
  root: {
    maxWidth: "100%",
    margin: "1rem 0.6rem",
    padding: "2.5rem 0 1rem 0",
    transition: "0.3s",
    background: "#fff",
    border: "2px solid #000",
    //
    //
    //
    // *** transparency card **
    //
    // background: "rgba(255,255,255,0.5)",
    // webkitBackdropFilter: `blur(15px)`,
    // backdropFilter: `blur(15px)`,
    //------------
    //
    borderRadius: "167px 167px 167px 167px;",
    //
    // *** MEDIA queries
    //
    [theme.breakpoints.down("xs")]: {
      padding: "1.5rem 1.5rem 2.5rem 1.5rem",
      background: "#fff",
      borderRadius: "104px 104px 104px 104px",
      borderTop: "4px solid #121212",
      borderLeft: "3px solid #121212",
      borderRight: "3px solid #121212",
      borderBottom: "9px solid #121212",
      margin: "1rem 0.2rem",
      //
      //

      backgroundImage: `linear-gradient(#e0f9f1 2px, transparent 2px), linear-gradient(to right, #e0f9f1 2px, transparent 2px)`,
      backgroundSize: "32px 32px",
      backgroundColor: "#ffffff",
      //
      //
    },
    [theme.breakpoints.up("sm")]: {
      // backgroundColor: "fuchsia",
      padding: "1.5rem 1.5rem 2.5rem 1.5rem",
      background: "#fff",
      borderRadius: "104px 104px 104px 104px",
      borderTop: "4px solid #121212",
      borderLeft: "3px solid #121212",
      borderRight: "3px solid #121212",
      borderBottom: "9px solid #121212",
      margin: "1rem 0.2rem",
      //
      backgroundImage: `linear-gradient(#e0f9f1 2px, transparent 2px), linear-gradient(to right, #e0f9f1 2px, transparent 2px)`,
      backgroundSize: "32px 32px",
      backgroundColor: "#ffffff",
    },
    [theme.breakpoints.up("md")]: {
      // backgroundColor: "green",
      borderRadius: "58px 58px 58px 58px",
      backgroundImage: `linear-gradient(#e0f9f1 2px, transparent 2px), linear-gradient(to right, #e0f9f1 2px, transparent 2px)`,
      backgroundSize: "32px 32px",
      backgroundColor: "#ffffff",
    },
    [theme.breakpoints.up("lg")]: {
      padding: "1rem 0.5rem 2.5rem 0.5rem",
      // backgroundColor: "#121212",
      borderRadius: "58px 58px 58px 58px",

      backgroundImage: `linear-gradient(#e0f9f1 2px, transparent 2px), linear-gradient(to right, #e0f9f1 2px, transparent 2px)`,
      backgroundSize: "32px 32px",
      backgroundColor: "#ffffff",
    },
    //
  },
  media: {
    // *** IMG box ***
    height: "0",
    padding: "56.25% 0 0 0",
    margin: "0 0 1rem 0",
    // paddingTop: "56.25%", // 16:9 default
    // borderRadius: "200px 200px 200px 200px",
    // boxShadow:
    //   "2px 5px 16px 0px #EEF9FD, 5px 5px 15px 5px rgba(239, 244, 246,0)",

    //
    //

    [theme.breakpoints.down("xs")]: {
      // border: "3px solid #121212",
      // borderRadius: "20px",

      borderTopLeftRadius: "200px",
      borderTopRightRadius: "200px",
      borderBottomLeftRadius: "65px",
      borderBottomRightRadius: "65px",
      border: "#121212 2px solid",
    },
    [theme.breakpoints.up("sm")]: {
      borderTopLeftRadius: "200px",
      borderTopRightRadius: "200px",
      borderBottomLeftRadius: "65px",
      borderBottomRightRadius: "65px",
      border: "#121212 4px solid",
    },
    [theme.breakpoints.up("md")]: {
      borderTopLeftRadius: "200px",
      borderTopRightRadius: "200px",
      borderBottomLeftRadius: "65px",
      borderBottomRightRadius: "65px",
      border: "#121212 4px solid",
    },
    [theme.breakpoints.up("lg")]: {
      borderRadius: "200px 200px 200px 200px",
      border: "3px solid #121212",
    },
  },
  //
  //
  //  *** CARD CONTENT ***

  cardContent: {
    // box nesting the "price and the name of the product "
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    background: "transparent", // *** PRICE
  },
  //
  // *** PRODUCT NAME
  //
  //
  productName: {
    letterSpacing: "1px",
    fontFamily: "Poppins-Light",
    fontWeight: "bold",
    fontSize: `calc(15px + 2vmin)`,
    opacity: "0.8",
    color: "#121212",
    // color: "rgba(255, 255, 251, 1)",

    // *** Media queries
    [theme.breakpoints.up("xs")]: {
      borderRadius: "58px 58px 58px 58px",
      fontSize: `calc(14px + 1.1vmin)`,
    },
    [theme.breakpoints.up("sm")]: { fontSize: `calc(15px + 1.1vmin)` },
    [theme.breakpoints.up("md")]: {},
    [theme.breakpoints.up("lg")]: {
      fontSize: `calc(10px + 1.1vmin)`,
    },
  },
  //
  //
  // *** PRICE card
  productPrice: {
    letterSpacing: "1px",
    color: "#121212",
    fontFamily: "PoppinsThin",
    fontWeight: "600",
    fontSize: "1.4em",
    opacity: "0.8",
    margin: "0 0 0.3em 0",
    // *** Media queries
    [theme.breakpoints.up("xs")]: {
      fontSize: `calc(14px + 1.1vmin)`,
    },
    [theme.breakpoints.up("sm")]: { fontSize: `calc(15px + 1.1vmin)` },
    [theme.breakpoints.up("md")]: {},
    [theme.breakpoints.up("lg")]: { fontSize: `calc(10px + 1.1vmin)` },
  },

  //

  //
  //
  // *** Wrapper of the icon & descript & arrow ***
  wrapperCardActions: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    //
    // border: "1px solid #000",
    //
    width: "100%",

    //
    // Media queries
    //
    [theme.breakpoints.down("xs")]: {
      // backgroundColor: "white",
      minHeight: "10vh",
      padding: "3vh 0",
    },
    [theme.breakpoints.up("sm")]: {
      // backgroundColor: "black",
    },
    [theme.breakpoints.up("md")]: {
      // backgroundColor: "salmon",
    },
    [theme.breakpoints.up("lg")]: {
      // backgroundColor: "#ccc",
      minHeight: "1vh",
    },
  },

  //
  //
  cardActions: {
    //
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexDirection: "row",
    //
    width: "99%",
    height: "30%",
    // border: "1px solid #000",
    //
    [theme.breakpoints.down("xs")]: {
      // backgroundColor: "papayawhip",
      flexDirection: "column",
      backgroundColor: "transparent",
    },
    [theme.breakpoints.up("sm")]: {
      // backgroundColor: "black",
    },
    [theme.breakpoints.up("md")]: {
      height: "30%",
      // backgroundColor: "salmon",
    },
    [theme.breakpoints.up("lg")]: {
      height: "30%",

      // backgroundColor: "salmon",
    },
  },
  //
  //
  //  *** Description Comp

  DescriptionComp: {
    display: "flex",
    flex: "2",
    height: "100%",
    justifyContent: "flex-start",
    alignItems: "center",

    //

    fontFamily: "Poppins-Light",
    fontSize: `calc(4px + 2vmin)`,
    lineHeight: `calc(8px + 2vmin)`,
    fontWeight: "600",
    //
    color: "#121212",
    textAlign: "justify",
    //color: "#ff0080", // magenta
    // opacity: "0.2",

    //
    borderRadius: "10px",
    // border: "1px solid #121212",
    // //
    //   Media queries
    //
    [theme.breakpoints.down("xs")]: {
      // backgroundColor: "papayawhip",
      color: "#121212",
      fontSize: `calc(10px + 1.4vmin)`,
      lineHeight: `calc(10px + 1.4vmin)`,
      width: "100%",
      padding: "10px 0",
      justifyContent: "center",
      alignItems: "center",
    },
    [theme.breakpoints.up("sm")]: {
      // backgroundColor: "black",

      fontSize: `calc(6px + 1.4vmin)`,
      lineHeight: `calc(7px + 1.4vmin)`,
      alignItems: "center",
    },
    [theme.breakpoints.up("md")]: {
      // backgroundColor: "salmon",
      fontSize: `calc(6px + 1.4vmin)`,
      lineHeight: `calc(7px + 1.4vmin)`,
    },
    [theme.breakpoints.up("lg")]: {
      // backgroundColor: "salmon",
      // "#ff0080",
      flex: "2",

      fontSize: `calc(3px + 1.4vmin)`,
      lineHeight: `calc(10px + 1.4vmin)`,
    },
    //
    //
  },
  //
  //--------------- ))
  // ***   SVG ICON
  //
  svgProductContainer: {
    backgroundColor: "pink",
    display: "flex",
    flex: "1",

    justifyContent: "center",
    //
    // Media Queries
    //
    [theme.breakpoints.down("xs")]: {
      backgroundColor: "papayawhip",
      display: "none",
    },
    [theme.breakpoints.up("sm")]: { display: "none" },
    [theme.breakpoints.up("md")]: { display: "none" },
    [theme.breakpoints.up("lg")]: {
      backgroundColor: "transparent",
      display: "none",
    },
  },

  svgBox: {
    maxWidth: "50%",
    padding: "0 10px",
  },
  //
  /*
  
  
  
  
    --------------------- ))
  
  
  
  */

  //*** ICON Add to cart
  //
  IconAddToCartActions: {
    // *** PARENT

    display: "flex",
    flex: "1",
    marginTop: "10px",
    //   background: "rgba(246, 246, 239, 1)",
    background: "rgba(255, 249, 141, 1)",
    color: "#121212",
    border: "1px solid #121212",
    borderRadius: "112px 112px 112px 112px",
    transition: "all 0.5s ease",

    overflow: "hidden",
    padding: "10px 0",

    //

    "&::after": {
      // zIndex: "4",
      zIndex: "1",
      content: '""', // you need to have it really like this '""',
      position: "absolute",
      height: "100%",
      width: "100%",
      transform: `scaleY(0)`,
      //

      bottom: "0",
      left: "0",
      border: "0 none",
      //
      background: "#00ffb3",
      /*line color*/
      transformOrigin: "bottom right",
      transition: "transform 1s ease-out",
      padding: "10px 0",
    },
    "&:hover": {
      "&:after": {
        transform: `scaleY(1)`,
        transformOrigin: "bottom left",
      },
    },
    //
    //#00ffb3
    // Media queries
    [theme.breakpoints.up("xs")]: {
      // marginTop: "10px",
      width: "100%",
      minWidth: "80px",
      borderLeft: "5px solid #121212",
      borderRight: "5px solid #121212",
      background: "#121212",
      color: "#fff",
      "&::after": {
        content: '""',
        background: "rgba(255, 249, 141, 1)",
      },
    },
    //   Media queries
    [theme.breakpoints.up("sm")]: {
      width: "100%",
      minWidth: "80px",
      borderLeft: "5px solid #121212",
      borderRight: "5px solid #121212",
      background: "#121212",
      color: "#fff",
      "&::after": {
        content: '""',
        background: "rgba(255, 249, 141, 1)",
      },
    },
    [theme.breakpoints.up("md")]: {},
    // ***  LG
    [theme.breakpoints.up("lg")]: {
      width: "100%",
      minWidth: "80px",
      borderLeft: "5px solid #121212",
      borderRight: "5px solid #121212",
      background: "rgba(255, 249, 141, 1)",
      color: "#121212",
      "&::after": {
        content: '""',
        background: "#00ffb3",
      },
      //
    },
  },

  //

  TheIconAddToCart: {
    // zIndex: "6",
    zIndex: "2",
    width: "28px",
    height: "28px",
    //
    [theme.breakpoints.down("xs")]: {},
    //
    [theme.breakpoints.up("sm")]: {
      // backgroundColor: "peru",
    },
    [theme.breakpoints.up("md")]: {
      // backgroundColor: "red",
    },
    [theme.breakpoints.up("lg")]: {
      // backgroundColor: "salmon",
    },
  },
}));
